var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('full-modal',{attrs:{"modal-title":"Property Portal Settings"}},[_c('property-actions',{attrs:{"property":_vm.$store.state.selectedProperty}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6614f52","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/property/settings/PropertySettingsPortal.vue
// module id = GEOC
// module chunks = 0 1